import React from "react";
import { FocusManager } from "./../../../ui-components/index.js";
import classes from "./DropdownModal-scss.js";
const DropdownModal = ({ options, jsdomMode, dataHook, ariaLabeledBy }) => {
  return /* @__PURE__ */ React.createElement(FocusManager, { jsdomMode, preventScroll: true }, /* @__PURE__ */ React.createElement("div", { className: classes.modal, "data-hook": dataHook }, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-hook": "dropdown-modal-options-wrapper",
      className: classes.dropdownModalOptionsWrapper,
      role: "listbox",
      "aria-labelledby": ariaLabeledBy
    },
    options
  )));
};
var DropdownModal_default = DropdownModal;
export {
  DropdownModal_default as default
};
//# sourceMappingURL=DropdownModal.js.map
